export default function CareerGoalsRankedSelection({
  disabled = false,
  items,
  onMove,
  testIDPrefix
}: {
  disabled?: boolean;
  items: Array<{ label: string; value: string }>;
  onMove: (index: number, direction: -1 | 1) => void;
  testIDPrefix: string;
}) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div
      className="mt-1 rounded-lg border border-sys-brand-outline bg-sys-brand-surface p-4"
      data-testid={`${testIDPrefix}-ranking`}
    >
      <h3 className="mb-4 text-title-medium-bold text-sys-brand-on-surface">Your Ranking</h3>
      <div className="flex flex-col gap-3">
        {items.map((item, index) => (
          <div className="flex items-center gap-3" key={item.value}>
            <span
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[6px] bg-extended-pgasilver-brand-color text-title-medium-bold text-extended-pgasilver-brand-on-color"
              data-testid={`${testIDPrefix}-rank-badge-${item.value}`}
            >
              {index + 1}
            </span>
            <span className="flex-1 text-body-large text-sys-brand-on-surface">{item.label}</span>
            <button
              type="button"
              aria-label={`Move ${item.label} up`}
              className={`px-2 py-1 text-label-large text-sys-brand-primary ${index === 0 ? "opacity-40" : ""}`}
              data-testid={`${testIDPrefix}-move-up-${item.value}`}
              disabled={disabled || index === 0}
              onClick={() => onMove(index, -1)}
            >
              Up
            </button>
            <button
              type="button"
              aria-label={`Move ${item.label} down`}
              className={`px-2 py-1 text-label-large text-sys-brand-primary ${
                index === items.length - 1 ? "opacity-40" : ""
              }`}
              data-testid={`${testIDPrefix}-move-down-${item.value}`}
              disabled={disabled || index === items.length - 1}
              onClick={() => onMove(index, 1)}
            >
              Down
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
